import { h } from 'preact'

export default function ({ user, mode }) {
  return user.reviewsPausedAt && h('div', { class: 'danger center' },
    `Your account is paused, so ${mode} are disabled`
  )
}
